import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/components/login/login.component';
import { canMatchAuthGuard } from './core/guards/auth.guard';
import { canMatchLoginGuard } from './core/guards/login.guard';

import { AdminLayoutComponent } from './core/layout/admin-layout/admin-layout.component';
import { adminRoutes } from './core/layout/admin-routes';

export const routes: Routes = [
  {
    path:'login',
    component:LoginComponent,
    canMatch: [canMatchLoginGuard]
  },
  {
        path:'',
        component:AdminLayoutComponent,
        children:adminRoutes,
        canMatch:[canMatchAuthGuard],
        runGuardsAndResolvers: 'always'
  },
  {
      path: '**',
      redirectTo: 'login',
      pathMatch: 'full'
  }
];
